// extracted by mini-css-extract-plugin
export default {"faq":"Faq_faq__emvT6","Accordion":"Faq_Accordion__AnGpX","AccordionSummary":"Faq_AccordionSummary__x2FXT","AccordionDetails":"Faq_AccordionDetails__30sIL"};